/* import __COLOCATED_TEMPLATE__ from './seller-profile-active-projects-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { htmlSafe } from '@ember/template'
import moment from 'moment';
import { stripTags } from 'sh-www/utils/misc';
import { COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS } from 'sh-www/constants/routes/company-profile';

export default class SellerProfileActiveProjectsCard extends Component {
  @service media;

  @tracked isLastMessageTruncated = true;

  get className() {
    return 'SH-c-seller-profile-freelancer-profile__active-projects-card';
  }

  get brandOrCompanyName() {
    const { application, company } = this.args;
    return htmlSafe(application.brand?.displayedName ?? company.name);
  }

  get status() {
    return parseFloat(this.args.application.status);
  }

  get title() {
    return htmlSafe(this.args.application.assignment.title);
  }

  // Overwriting the statusColor until unified approach is made
  get statusTagClassName() {
    let statusColor = 'lsg-dark-gray';
    if (this.status === 3) {
      statusColor = 'lsg-green';
    } else if (this.status > 3) {
      statusColor = 'lsg-yellow';
    }
    return this.className + "__status__" + statusColor;
  }

  // Overwriting the statusText until unified approach is made
  get statusText() {
    switch (this.status) {
      case 0:
        return "Make an offer";
      case 1:
        return "Awaiting offer acceptance";
      case 2:
        return "Review offer";
      case 2.5:
        return "Awaiting contract signature";
      case 3:
        return "Active";
      case 3.5:
        return "Confirm completion";
      case 3.75:
        return "Awaiting completion confirmation";
      default:
        return this.args.application.statusText;
    }
  }

  get lastActivity() {
    return `Last activity ${moment(this.args.application.updatedAt).fromNow()}`;
  }

  get lastMessage() {
    const lastMessageText = stripTags(this.args.application.thread.lastMessage, []);

    if (this.media.isMobile) {
      if (lastMessageText.length < COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_MOBILE) {
        this.isLastMessageTruncated = false;
        return descriptionText;
      }
        return lastMessageText.slice(0, COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_MOBILE);
    }

    else if (this.media.isMediumAndDown) {
      if (lastMessageText.length < COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_MEDIUM_AND_DOWN) {
        this.isLastMessageTruncated = false;
        return lastMessageText;
      }
        return lastMessageText.slice(0, COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_MEDIUM_AND_DOWN);
    }

    if (lastMessageText.length < COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_LARGE_AND_UP) {
      this.isLastMessageTruncated = false;
      return lastMessageText;
    }

    return lastMessageText.slice(0, COMPANY_PROFILE__COMPANY_MANAGEMENT__CARD_DESCRIPTION_LENGTHS.CHARACTER_COUNT_LARGE_AND_UP);
  }
}
